(function(){
  var root = document.currentScript.previousElementSibling;
  while (root && !(root.classList && root.classList.contains('pdp'))) { root = root.previousElementSibling; }
  if(!root) return;

  var main = root.querySelector('[data-gallery-main]');
  var video = root.querySelector('[data-gallery-video]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  var track = root.querySelector('[data-thumbs-track]');
  var idx = 0;
  function showImage(t){
    if(video){ video.pause(); video.hidden = true; video.removeAttribute('src'); try { video.load(); } catch(e){} }
    if(main){ main.style.visibility = ''; if(t) main.style.backgroundImage = "url('" + t.getAttribute('data-img') + "')"; }
  }
  function showVideo(t){
    if(!video) return;
    video.src = t.getAttribute('data-video');
    var poster = t.getAttribute('data-poster'); if(poster) video.poster = poster;
    video.hidden = false; if(main) main.style.visibility = 'hidden'; video.muted = true;
    var pr = video.play(); if(pr && pr.catch) pr.catch(function(){});
  }
  function setActive(i){
    if(!thumbs.length) return;
    if(i < 0) i = thumbs.length - 1; if(i >= thumbs.length) i = 0; idx = i;
    var t = thumbs[idx];
    if(t && t.getAttribute('data-type') === 'video'){ showVideo(t); } else { showImage(t); }
    thumbs.forEach(function(x){ x.classList.remove('is-active'); });
    if(t){ t.classList.add('is-active'); if(track){ var left = t.offsetLeft - (track.clientWidth - t.clientWidth) / 2; track.scrollTo({ left: left, behavior: 'smooth' }); } }
  }
  thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ setActive(i); }); });
  var gPrev = root.querySelector('[data-gal-prev]'), gNext = root.querySelector('[data-gal-next]');
  if(gPrev) gPrev.addEventListener('click', function(){ setActive(idx - 1); });
  if(gNext) gNext.addEventListener('click', function(){ setActive(idx + 1); });
  var tPrev = root.querySelector('[data-thumbs-prev]'), tNext = root.querySelector('[data-thumbs-next]');
  function scrollThumbs(dir){ if(track) track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 120), behavior: 'smooth' }); }
  if(tPrev) tPrev.addEventListener('click', function(){ scrollThumbs(-1); });
  if(tNext) tNext.addEventListener('click', function(){ scrollThumbs(1); });

  var fitOpen = root.querySelector('[data-fit-open]');
  if(fitOpen){
    var openSelector = function(e){
      if(e) e.preventDefault();
      // Mobile: the desktop vehicle chip is hidden, and the fitment selector
      // lives inside the slide-out nav. Open the nav, then expand the vehicle
      // panel and scroll it into view.
      var isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if(isMobile){
        var navOpen = document.querySelector('[data-nav-open]');
        if(navOpen) navOpen.click();
        setTimeout(function(){
          var vehToggle = document.querySelector('[data-mob-veh-toggle]');
          if(vehToggle && vehToggle.getAttribute('aria-expanded') !== 'true'){ vehToggle.click(); }
          var panel = document.querySelector('.hf-mobnav__veh-panel[data-veh-strip]');
          if(panel){ try { panel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch(err){} }
        }, 380);
      } else {
        var chip = document.querySelector('.hf-vehicle-chip');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){ if(chip) chip.click(); }, 480);
      }
    };
    fitOpen.addEventListener('click', openSelector);
    fitOpen.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' ') openSelector(e); });
  }

  var tabsWrap = root.querySelector('[data-tabs]');
  if(tabsWrap){
    var tbtns = tabsWrap.querySelectorAll('.f20-tabs__tab');
    var panels = tabsWrap.querySelectorAll('.f20-tabs__panel');
    tbtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-tab');
        tbtns.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
        panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
      });
    });
  }

  // Quantity stepper (self-contained — unique data attrs so no legacy handler collides)
  var qtyWrap = root.querySelector('[data-hfqty]');
  if(qtyWrap){
    var qInput = qtyWrap.querySelector('input');
    var qDec = qtyWrap.querySelector('[data-hfqty-dec]');
    var qInc = qtyWrap.querySelector('[data-hfqty-inc]');
    var setQ = function(v){ if(isNaN(v) || v < 1) v = 1; qInput.value = v; };
    if(qDec) qDec.addEventListener('click', function(){ setQ(parseInt(qInput.value, 10) - 1); });
    if(qInc) qInc.addEventListener('click', function(){ setQ(parseInt(qInput.value, 10) + 1); });
  }

  // Custom Shop Pay button triggers the real (hidden) dynamic checkout
  var hfSp = root.querySelector('[data-hf-shoppay]');
  if(hfSp){
    hfSp.addEventListener('click', function(){
      var real = root.querySelector('.pdp__shoppay-real'); if(!real) return;
      var sp = real.querySelector('shop-pay-button'); if(sp && sp.click){ sp.click(); return; }
      var b = real.querySelector('button, a, [role=\"button\"]'); if(b) b.click();
    });
  }

  // Variant selector (self-contained)
  var optBtns = root.querySelectorAll('[data-hf-opt]');
  if(optBtns.length){
    var vEl = root.querySelector('[data-hf-variants]');
    var oEl = root.querySelector('[data-hf-options]');
    var variants = []; var optionNames = [];
    try { variants = JSON.parse(vEl.textContent); } catch(e){}
    try { optionNames = JSON.parse(oEl.textContent); } catch(e){}
    var hfMoney = function(c){ return '$' + (c/100).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}); };
    var hfSelected = function(){
      var sel = {};
      root.querySelectorAll('.pdp__options').forEach(function(g){
        var a = g.querySelector('[data-hf-opt].is-active') || g.querySelector('[data-hf-opt]');
        if(a) sel[a.getAttribute('data-option-name')] = a.getAttribute('data-option-value');
      });
      return sel;
    };
    var hfShowImage = function(src){
      if(!src) return;
      var fbase = src.split('?')[0]; fbase = fbase.substring(fbase.lastIndexOf('/') + 1);
      var ti = -1;
      for(var k=0;k<thumbs.length;k++){ if((thumbs[k].getAttribute('data-img') || '').indexOf(fbase) !== -1){ ti = k; break; } }
      if(ti >= 0){ setActive(ti); }
      else if(main){ if(video){ try { video.pause(); } catch(e){} video.hidden = true; } main.style.visibility = ''; main.style.backgroundImage = "url('" + src + "')"; }
    };
    var hfUpdate = function(){
      var sel = hfSelected(); var m = null;
      for(var i=0;i<variants.length;i++){
        var v = variants[i], ok = true;
        for(var j=0;j<optionNames.length;j++){ if(v.options[j] !== sel[optionNames[j]]){ ok = false; break; } }
        if(ok){ m = v; break; }
      }
      if(!m) return;
      root.querySelectorAll('[data-variant-id], [data-variant-id-atc]').forEach(function(inp){ inp.value = m.id; });
      var pm = root.querySelector('.pdp-price__main'); if(pm) pm.textContent = hfMoney(m.price);
      var po = root.querySelector('.pdp__price-old');
      if(po){ if(m.compare_at_price && m.compare_at_price > m.price){ po.textContent = hfMoney(m.compare_at_price); po.style.display = ''; } else { po.style.display = 'none'; } }
      var atc = root.querySelector('[data-atc-btn]');
      if(atc){ atc.disabled = !m.available; atc.textContent = m.available ? ('Add to cart · ' + hfMoney(m.price) + ' →') : 'Sold out'; }
      var av = root.querySelector('.pdp__avail'); if(av){ av.innerHTML = '<span class="pdp__avail-dot"></span>' + (m.available ? 'In stock · Ready to ship' : 'Currently unavailable'); }
      var inst = root.querySelector('[data-hf-installment]'); if(inst){ inst.textContent = hfMoney(m.price / 4); }
      if(m.featured_image && m.featured_image.src){ hfShowImage(m.featured_image.src); }
    };
    optBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var g = btn.closest('.pdp__options');
        if(g) g.querySelectorAll('[data-hf-opt]').forEach(function(b){ b.classList.toggle('is-active', b === btn); });
        var row = btn.closest('.pdp__opt-row'); if(row){ var lbl = row.querySelector('.label-cap span'); if(lbl) lbl.textContent = btn.getAttribute('data-option-value'); }
        hfUpdate();
      });
    });
  }

  try {
    var labels = (localStorage.getItem('ymm_labels') || '').split('~').filter(Boolean);
    if(labels.length >= 3){
      var fit = root.querySelector('[data-fit]');
      if(fit){
        fit.classList.add('is-confirmed');
        var icon = fit.querySelector('[data-fit-icon]');
        if(icon){ icon.classList.remove('is-unknown'); icon.innerHTML = '<i data-lucide="check" width="16" height="16"></i>'; }
        var txt = fit.querySelector('[data-fit-text]');
        if(txt){ txt.innerHTML = '<strong>Fits your ' + labels[0] + ' ' + labels[1] + ' ' + labels[2] + '</strong><small>Compatible with standard 2&quot; hitch receiver</small>'; }
        var chg = fit.querySelector('[data-fit-change]');
        if(chg){ chg.hidden = false; chg.addEventListener('click', function(){ localStorage.removeItem('ymm_values'); localStorage.removeItem('ymm_labels'); location.reload(); }); }
      }
    }
  } catch(e){}

  var addonsSlot = root.querySelector('[data-hf-addons-slot]');
  function relocateAddons(){
    if(!addonsSlot) return;
    root.querySelectorAll('lb-upsell-product-page-addon').forEach(function(el){ if(el.parentElement !== addonsSlot) addonsSlot.appendChild(el); });
  }
  relocateAddons();
  if(window.MutationObserver){ var info = root.querySelector('.pdp__info') || root; var mo = new MutationObserver(function(){ relocateAddons(); }); mo.observe(info, { childList: true, subtree: true }); }

  function hfIcons(){ if(window.lucide) window.lucide.createIcons(); }
  if(document.readyState !== 'loading') hfIcons(); else document.addEventListener('DOMContentLoaded', hfIcons);
})();
